import SysManager from '@/views/SysManager'
/* 
 分类信息管理
*/
// 出版社排行
import PublisherRank from '@/views/SysManager/ClassifyInfo/PublisherRank'
// 书籍排行
import BookRank from '@/views/sysmanager/ClassifyInfo/BookRank'
// 出版社推荐
import PublisherSuggest from '@/views/sysmanager/ClassifyInfo/PublisherSuggest'
// 书籍推荐
import BookSuggest from '@/views/sysmanager/ClassifyInfo/BookSuggest'
import SurroundSuggest from '@/views/sysmanager/ClassifyInfo/SurroundSuggest'
// 创建直播
import CreatVhall from '@/views/Live-Platform/creat-vhall'
// 创建录播
import creatLubo from '@/views/Live-Platform/creat-lubo'
// 直播列表
import Livelist from '@/views/Live-Platform/Live-list'
// 展会排程
import PlanList from '@/views/Live-Platform/Plan-List'
/**
 * 展会信息管理
 */
import HomeSetup from '@/views/SysManager/ExhibitionInfo/HomeSetup'
import OtherCategory from '@/views/SysManager/ClassifyInfo/OtherCategory'
import PhotoWall from '@/views/SysManager/ExhibitionInfo/PhotoWall/index'
import Order from '@/views/SysManager/Order/index'
// 带货链接配置
import SetLiveLink from '@/views/SysManager/setLiveLink/App'
const sysmangerRouter = {
  path: '/sysmanager',
  component: SysManager,
  children: [
    {
      path: '/',
      name: 'HomeSetup',
      component: HomeSetup
    },
    {
      path: '/bookrank',
      name: 'BookRank',
      component: BookRank
    },
    {
      path: '/publishersuggest',
      name: 'PublisherSuggest',
      component: PublisherSuggest
    }
    ,
    {
      path: '/booksuggest',
      name: 'BookSuggest',
      component: BookSuggest
    }
    ,
    {
      path: '/surroundsuggest',
      name: 'SurroundSuggest',
      component: SurroundSuggest
    },
    {
      path: '/PlanList', // 展会排程
      name: 'PlanList',
      component: PlanList
    },
    {
      path: '/CreatVhall', // 创建直播
      name: 'CreatVhall',
      component: CreatVhall
    },
    {
      path: '/creatLubo', // 创建录播
      name: 'creatLubo',
      component: creatLubo
    },
    {
      path: '/Livelist', // 直播列表
      name: 'Livelist',
      component: Livelist
    },
    {
      path: '/publisherRank',
      name: 'PublisherRank',
      component: PublisherRank
    }
    ,
    {
      path: '/OtherCategory',
      name: 'OtherCategory',
      component: OtherCategory
    },

    {
      path: '/PhotoWall',
      name: 'PhotoWall',
      component: PhotoWall
    },
    {
      path: '/OrderView',
      name: 'OrderView',
      component: Order
    },
    {
      path: '/SetLiveLink',
      name: 'SetLiveLink',
      component: SetLiveLink
    }
  ]
}
export default sysmangerRouter



// WEBPACK FOOTER //
// ./src/router/sysmanager.js